import { LRUObjectCache } from "./lruObjectCache";

/**
 * O(1) LRU cache for string keys. A thin specialization of {@link LRUObjectCache}
 * with no comparator, so keys are matched by Map identity (`===` for strings) —
 * giving O(1) `get`/`add`/`delete` and Map-insertion-order recency.
 */
export class LRUStringCache<V> extends LRUObjectCache<string, V> {
  constructor(size: number) {
    super(size);
  }
}
